
export default{

    app:{
        home_title:"Sale of Macao SAR Government Publications",
        home_address:"Detailed address",
        home_lr:"Latest Recommended",
        home_publisher:"Publisher",
        home_publishlang:"Language",
        home_publishdate:"Publish Date",
        home_search:"Title / Author / Editorial Institution",
        home_cancel:"Cancel",
        home_detail_title:"Publication details",
        home_ml:"content",
        home_category:"Category",
        home_author:"Author",
        home_soldmaiche:"Vending machine",
        home_search_item :"Search",
        home_sure:"Confirm",
        // home_selectSoldMachie:"Please select a vending machine",
        home_soldOut:"sold out",
        home_free:"Free",
        home_selectSoldMachie:"Total of vending machines",
    
    }
}